module.exports = __webpack_public_path__ + "static/media/logo.4b5bb237.svg";